import SpecialBogo from 'src/dispensary/specials/offer';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(SpecialBogo, MainDispensaryLayout);
